var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoftlandLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "118px",
    height: "39px",
    viewBox: "0 0 119 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.917647,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(10.980392%,64.705882%,91.764706%)",
      fillOpacity: 1
    },
    d: "M 5.832031 7.949219 C 9.265625 7.238281 12.15625 8.136719 14.5 10.648438 C 13.792969 11.609375 12.945312 12.410156 11.960938 13.050781 C 9.5625 11.050781 7.171875 11.050781 4.785156 13.050781 C 3.078125 15.820312 3.527344 18.171875 6.128906 20.101562 C 7.941406 20.808594 9.632812 20.609375 11.210938 19.5 C 11.496094 19.285156 11.546875 19.035156 11.363281 18.75 C 10.484375 18.082031 9.886719 17.28125 9.566406 16.351562 C 14.324219 12.578125 18.707031 12.976562 22.722656 17.550781 C 24.964844 22.101562 24.117188 25.949219 20.183594 29.101562 C 17.191406 30.5 14.203125 30.5 11.210938 29.101562 C 10.472656 28.707031 9.875 28.15625 9.417969 27.449219 C 10.125 26.488281 10.972656 25.691406 11.960938 25.050781 C 14.359375 27.050781 16.75 27.050781 19.136719 25.050781 C 20.921875 22.113281 20.375 19.765625 17.492188 18 C 15.535156 17.199219 13.839844 17.550781 12.410156 19.050781 C 13 19.796875 13.648438 20.496094 14.351562 21.148438 C 14.550781 21.351562 14.550781 21.550781 14.351562 21.75 C 11.125 24.65625 7.589844 25.105469 3.738281 23.101562 C 0.234375 20.449219 -0.8125 16.996094 0.597656 12.75 C 1.644531 10.347656 3.390625 8.746094 5.832031 7.949219 Z M 5.832031 7.949219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.894118,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,8.235294%,69.803922%)",
      fillOpacity: 1
    },
    d: "M 35.429688 10.351562 C 37.441406 10.324219 39.332031 10.773438 41.113281 11.699219 C 43.265625 13.335938 43.015625 14.488281 40.363281 15.148438 C 38.640625 13.664062 36.695312 13.214844 34.535156 13.800781 C 32.839844 14.996094 32.9375 15.996094 34.832031 16.800781 C 37 17.011719 39.09375 17.511719 41.113281 18.300781 C 43.683594 20.699219 43.882812 23.296875 41.710938 26.101562 C 37.6875 28.464844 33.847656 28.214844 30.199219 25.351562 C 29.789062 24.789062 29.441406 24.1875 29.152344 23.550781 C 30 22.972656 30.898438 22.472656 31.84375 22.050781 C 33.714844 24.433594 36.109375 25.082031 39.019531 24 C 40.214844 23 40.214844 22 39.019531 21 C 36.933594 20.476562 34.839844 19.976562 32.738281 19.5 C 30.074219 18.0625 29.328125 15.914062 30.496094 13.050781 C 31.851562 11.546875 33.496094 10.644531 35.429688 10.351562 Z M 35.429688 10.351562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.882353,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,8.235294%,69.411765%)",
      fillOpacity: 1
    },
    d: "M 62.042969 10.648438 C 63.660156 10.476562 65.054688 10.925781 66.226562 12 C 66.007812 12.640625 65.707031 13.242188 65.332031 13.800781 C 64.347656 13.6875 63.351562 13.6875 62.339844 13.800781 C 62.140625 14.398438 61.941406 15 61.742188 15.601562 C 63.535156 15.75 65.328125 15.800781 67.125 15.75 C 67.125 14.75 67.125 13.75 67.125 12.75 C 68.230469 12.734375 69.328125 12.632812 70.414062 12.449219 C 70.414062 13.550781 70.414062 14.648438 70.414062 15.75 C 71.410156 15.75 72.40625 15.75 73.402344 15.75 C 73.402344 16.648438 73.402344 17.550781 73.402344 18.449219 C 72.40625 18.449219 71.410156 18.449219 70.414062 18.449219 C 70.363281 20.253906 70.414062 22.054688 70.5625 23.851562 C 70.804688 24.242188 71.152344 24.441406 71.609375 24.449219 C 72.136719 24.167969 72.632812 24.167969 73.105469 24.449219 C 73.472656 25.179688 73.769531 25.929688 74 26.699219 C 72.222656 27.695312 70.429688 27.695312 68.621094 26.699219 C 68.15625 26.335938 67.808594 25.886719 67.574219 25.351562 C 67.15625 23.074219 67.007812 20.777344 67.125 18.449219 C 65.328125 18.398438 63.535156 18.449219 61.742188 18.601562 C 62.035156 21.425781 62.136719 24.273438 62.042969 27.148438 C 60.945312 27.148438 59.847656 27.148438 58.753906 27.148438 C 58.753906 24.25 58.753906 21.351562 58.753906 18.449219 C 58.054688 18.449219 57.355469 18.449219 56.660156 18.449219 C 56.660156 17.550781 56.660156 16.648438 56.660156 15.75 C 57.355469 15.75 58.054688 15.75 58.753906 15.75 C 58.53125 13.175781 59.625 11.476562 62.042969 10.648438 Z M 62.042969 10.648438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.890196,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,8.235294%,69.411765%)",
      fillOpacity: 1
    },
    d: "M 74.898438 10.949219 C 75.996094 10.949219 77.089844 10.949219 78.1875 10.949219 C 78.1875 16.351562 78.1875 21.75 78.1875 27.148438 C 77.089844 27.148438 75.996094 27.148438 74.898438 27.148438 C 74.898438 21.75 74.898438 16.351562 74.898438 10.949219 Z M 74.898438 10.949219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.898039,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,8.235294%,69.411765%)",
      fillOpacity: 1
    },
    d: "M 115.261719 10.949219 C 116.257812 10.949219 117.257812 10.949219 118.253906 10.949219 C 118.253906 16.351562 118.253906 21.75 118.253906 27.148438 C 117.257812 27.148438 116.257812 27.148438 115.261719 27.148438 C 115.222656 26.167969 114.824219 26.117188 114.066406 27 C 109.226562 28.222656 106.4375 26.375 105.695312 21.449219 C 106.058594 17.015625 108.449219 15.066406 112.871094 15.601562 C 113.675781 15.828125 114.425781 16.179688 115.113281 16.648438 C 115.261719 14.753906 115.3125 12.851562 115.261719 10.949219 Z M 110.777344 18.449219 C 113.15625 18.140625 114.554688 19.140625 114.964844 21.449219 C 114.855469 23.359375 113.859375 24.359375 111.972656 24.449219 C 109.722656 24.136719 108.773438 22.835938 109.132812 20.550781 C 109.414062 19.621094 109.960938 18.921875 110.777344 18.449219 Z M 110.777344 18.449219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.890196,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,8.235294%,69.803922%)",
      fillOpacity: 1
    },
    d: "M 48.886719 15.449219 C 54.109375 15.242188 56.550781 17.742188 56.210938 22.949219 C 54.910156 26.53125 52.367188 27.980469 48.585938 27.300781 C 45.761719 26.386719 44.269531 24.4375 44.101562 21.449219 C 44.296875 18.261719 45.890625 16.261719 48.886719 15.449219 Z M 49.183594 18.449219 C 52.441406 18.480469 53.589844 20.082031 52.625 23.25 C 51.027344 24.851562 49.433594 24.851562 47.839844 23.25 C 47.113281 21.289062 47.5625 19.691406 49.183594 18.449219 Z M 49.183594 18.449219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.901961,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,8.235294%,69.411765%)",
      fillOpacity: 1
    },
    d: "M 83.570312 15.449219 C 85.394531 15.195312 87.039062 15.59375 88.503906 16.648438 C 88.648438 16.367188 88.695312 16.066406 88.652344 15.75 C 89.75 15.75 90.84375 15.75 91.941406 15.75 C 91.941406 19.550781 91.941406 23.351562 91.941406 27.148438 C 90.84375 27.148438 89.75 27.148438 88.652344 27.148438 C 88.695312 26.835938 88.648438 26.535156 88.503906 26.25 C 88.03125 26.710938 87.480469 27.0625 86.859375 27.300781 C 83.777344 28.039062 81.433594 27.089844 79.832031 24.449219 C 78.332031 20.199219 79.578125 17.199219 83.570312 15.449219 Z M 84.167969 18.449219 C 86.738281 17.886719 88.234375 18.886719 88.652344 21.449219 C 88.464844 23.386719 87.417969 24.488281 85.511719 24.75 C 82.636719 23.898438 81.839844 22.097656 83.121094 19.351562 C 83.464844 19.007812 83.8125 18.710938 84.167969 18.449219 Z M 84.167969 18.449219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.886275,
      stroke: "none"
    }
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 39
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface26",
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,8.235294%,69.411765%)",
      fillOpacity: 1
    },
    d: "M 98.816406 15.449219 C 101.890625 15.285156 103.832031 16.683594 104.648438 19.648438 C 104.796875 22.148438 104.847656 24.648438 104.796875 27.148438 C 103.703125 27.148438 102.605469 27.148438 101.507812 27.148438 C 101.558594 24.746094 101.507812 22.347656 101.359375 19.949219 C 100.457031 18.4375 99.210938 18.089844 97.621094 18.898438 C 97.027344 19.296875 96.679688 19.84375 96.574219 20.550781 C 96.425781 22.746094 96.375 24.949219 96.425781 27.148438 C 95.328125 27.148438 94.234375 27.148438 93.136719 27.148438 C 93.136719 23.351562 93.136719 19.550781 93.136719 15.75 C 94.132812 15.75 95.128906 15.75 96.125 15.75 C 96.078125 16.160156 96.128906 16.5625 96.277344 16.949219 C 97.078125 16.324219 97.925781 15.824219 98.816406 15.449219 Z M 98.816406 15.449219 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface26",
    mask: "url(#mask7)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftlandLogo);
export default __webpack_public_path__ + "static/media/Softland-logo.e97a42c054bd0151bebc4373a046fa84.svg";
export { ForwardRef as ReactComponent };